<template>
  <div class="harvestAddress">
    <!-- 地址修改 -->
    <allNav myTitle="地址编辑" ></allNav>
    <van-address-edit
    :area-list="areaList"
    :address-info="AddressInfo"
    show-postal
    show-delete
    show-set-default
    show-search-result
    :search-result="searchResult"
    :area-columns-placeholder="['请选择', '请选择', '请选择']"
    @save="onSave"
    @delete="onDelete"/>
  </div>
</template>

<script>
import allNav from "./allNav"
import areaList from "../../../assets/adress"
export default {
    components:{
        allNav
    },
    data(){
        return {
            areaList:areaList,
            searchResult:[],
            AddressInfo:{
                id:"",
                name:"",
                tel:"",
                province:"",
                city:"",
                county:"",
                addressDetail:"",
                areaCode:"",
                postalCode:"",
                isDefault:false,
            }
        }
    },
    created(){
        // console.log(this.$route.query.index);
        if(this.$route.query.id){
            this.getSelf();
        }
    },
    methods:{
        onSave(val) {
            var data={
                id: this.$route.query.id?this.$route.query.id:'',
                userId: window.localStorage.civilizationId, //会员的Id	
                receiverName: val.name,		//提货人名字	
                receiverPhone: val.tel,		//提货人手机号	
                receiverMobile: '', 	    //提货人手机	
                receiverPrivince: val.province, //省份	
                receiverCity: val.city, 		//城市	
                receiverDistrict: val.county, 	//区县	
                receiverAddress: val.addressDetail,	//具体地址	
                receiverZip: val.postalCode,	 	//邮编	
                checked: val.isDefault?1:0,	 		//是不是默认地址	
                typeId: this.wenOrRong //1是文明实践中心 2是融媒体
            }
            this.$http.post(this.javalinkTwo +"mmall/shipping/userSaveShipping",data,{headers:{'Content-Type': 'application/json'}})
            .then(res => {
                if(res.data.success){
                    this.$router.back(-1);
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        //获取自提地址
        getSelf(){
            this.$http.get(this.javalinkTwo +"mmall/shipping/selectUserById?userId="+window.localStorage.civilizationId)
            .then(res => {
                if(res.data.success){
                    var adress=res.data.data[this.$route.query.index];
                    this.AddressInfo.id=adress.id;
                    this.AddressInfo.name=adress.receiverName;
                    this.AddressInfo.tel=adress.receiverPhone;
                    this.AddressInfo.province=adress.receiverPrivince;
                    this.AddressInfo.city=adress.receiverCity;
                    this.AddressInfo.county=adress.receiverDistrict;
                    this.AddressInfo.addressDetail=adress.receiverAddress;
                    this.AddressInfo.areaCode="";
                    this.AddressInfo.postalCode=adress.receiverZip;
                    this.AddressInfo.isDefault=adress.checked==1?true:false;
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        onDelete(){
            // console.log("删除");
            if(this.$route.query.id){
                this.$http.get(this.javalinkTwo +"mmall/shipping/delShippingById?shippingId="+this.$route.query.id)
                .then(res => {
                    if(res.data.success){
                        this.$router.back(-1);
                    }
                })
                .catch(err => {
                    console.log(err)
                });
            }else{
                this.$router.back(-1);
            }
        }
    }
}
</script>

<style lang="less" scoped>
    .harvestAddress{
        width: 100%;
        height:100%;
    }
    .allNav{
        width: 100%;
        height: 64px;
        padding: 0px 12px;
        padding-top: 24px;
        box-sizing: border-box;
        font-size: 16px;
    }
    .mynavContent{
       width: 100%;
       height: 100%;
       display: flex;
       justify-content: space-between;
       align-items: center;
    }
</style>